import React from "react";
import classNames from "classnames";

import "../QuizLayout.css";

const QuizLayout = ({ className, children, ...props }) => (
  <div className={classNames("QuizLayout", className)} {...props}>
    {children}
  </div>
);

export default QuizLayout;

export const QuizMain = ({ className, children, ...props }) => (
  <div className={classNames("QuizMain", className)} {...props}>
    {children}
  </div>
);

export const QuizInput = ({ className, children, ...props }) => (
  <div className={classNames("QuizInput", className)} {...props}>
    {children}
  </div>
);
